// 项目全局所需配置项
// 判断是否是正式环境
export var baseUrl = location.host.includes("yxt.qytyw.com") ? "http://yxt.qytyw.com" : "http://yxt.qwqycl.com";
// export var apiBaseUrl = location.host.includes("yxt.qytyw.com") ? "https://yxtapi.qytyw.com/apipost" : location.host.includes("yxt.qwqycl.com") ? "https://yxtapi.qwqycl.com/apipost" : "apipost";

export var apiBaseUrl = location.host.includes("yxt.qytyw.com") ? "https://yxtapi.qytyw.com/apipost" : "https://yxtapi.qwqycl.com/apipost";

export var apiBaseUrlForXnh = "https://apixnh.xnhkfpt.com";

export var phoneReg = /^1[3456789]\d{9}$/;
export var emailReg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
export var idcardReg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
export var telephoneReg = /^((\+?86)|(\(\+86\)))?(13[012356789][0-9]{8}|15[012356789][0-9]{8}|18[02356789][0-9]{8}|147[0-9]{8}|1349[0-9]{7})$/;

// 接口请求类似于账号密码
export var appkeyValue = "customhfive";
export var appSecretKeyValue = "kLCDAH88";

// 如果是对象 那么返回true 否则返回false
export function isObj(obj) {
  return Object.prototype.toString.call(obj) === "[object Object]";
}

/**
 * @param {array} arr - 需要去重的数组
 * @param {string} name - 需要去重的字段
 * @returns {array} 返回去重后的新数组
 * @version 1.0.0
 * @description 对数组本身进行某个字段的去重
 * @public
 **/
export function distinct(arr, name) {
  var hash = {};
  return arr.reduce(function(item, next) {
    hash[next[name]] ? "" : hash[next[name]] = true && item.push(next);
    return item;
  }, []);
}

// 获取链接
export function getURLQueryString(name) {
  var url = decodeURIComponent(window.location.href);
  url = url.replace(/&quot/g, '"');
  var r;
  if (url.indexOf("#?") > 0) {
    url = url.replace("#?", "&");
    r = url.match(new RegExp("(^|&)" + name + "=([^&]*)(&|$)"));
  } else {
    r = window.location.search.substr(1).match(new RegExp("(^|&)" + name + "=([^&]*)(&|$)"));
  }
  return r ? r[2] : null;
}

// excel流数据导出excel
export function exportExcel(data, name) {
  let blob = new Blob([data], { type: "application/vnd.ms-excel" }); // 设置文件类型excel
  let url = window.URL.createObjectURL(blob); // 创建一个临时的url指向blob对象
  // 创建url之后可以模拟对此文件对象的一系列操作，例如：预览、下载
  let a = document.createElement("a");
  a.href = url;
  a.download = name + ".xlsx";
  a.click();
  // 释放这个临时的对象url
  window.URL.revokeObjectURL(url);
}

function isClass(o) {
  if (o === null) return "Null";
  if (o === undefined) return "Undefined";
  return Object.prototype.toString.call(o).slice(8, -1);
}

// 深度克隆
export function deepClone(obj) {
  if (!obj) {
    return null;
  }
  var result;var oClass = isClass(obj);
  // 确定result的类型
  if (oClass === "Object") {
    result = {};
  } else if (oClass === "Array") {
    result = [];
  } else {
    return obj;
  }

  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      var copy = obj[key];
      if (isClass(copy) == "Object") {
        result[key] = deepClone(copy); // 递归调用
      } else if (isClass(copy) == "Array") {
        result[key] = deepClone(copy);
      } else {
        result[key] = obj[key];
      }
    }
  }
  return result;
}
// 获取浏览器类型
export function getBrowserType() {
  var userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串
  var browser = "unknown";
  if (userAgent.indexOf("IE") != -1) {
    browser = "IE";
  } else if (userAgent.indexOf("Firefox") != -1) {
    browser = "Firefox";
  } else if (userAgent.indexOf("OPR") != -1) {
    browser = "Opera";
  } else if (userAgent.indexOf("Chrome") != -1) {
    browser = "Chrome";
  } else if (userAgent.indexOf("Safari") != -1) {
    browser = "Safari";
  } else if (userAgent.indexOf("Trident") != -1) {
    browser = "IE 11";
  }
  return browser;
}

// 校验是否为手机或固话号码
export function checkNumber(numStr) {
  var isTel = /(([0-9]{3,4}-)[0-9]{7,8})|([0-9]{12})|([0-9]{11})|([0-9]{10})|([0-9]{9})|([0-9]{8})|([0-9]{7})/g;
  var isChinaMobile =
    /^134[0-8]\d{7}$|^(?:13[5-9]|147|15[0-27-9]|178|1703|1705|1706|18[2-478])\d{7,8}$/; // 移动
  var isChinaUniom = /^(?:13[0-2]|145|15[56]|176|1704|1707|1708|1709|171|18[56])\d{7,8}$/; // 联通
  var isChinaTelcom = /^(?:133|153|1700|1701|1702|177|173|18[019])\d{7,8}$/; // 电信
  return isTel.test(numStr) || isChinaMobile.test(numStr) || isChinaUniom.test(numStr) || isChinaTelcom.test(numStr);
}

// 校验是否为手机号码
export function checkNumberForMobile(numStr) {
  var isChinaMobile =
    /^134[0-8]\d{7}$|^(?:13[5-9]|147|15[0-27-9]|178|1703|1705|1706|18[2-478])\d{7,8}$/; // 移动
  var isChinaUniom = /^(?:13[0-2]|145|15[56]|176|1704|1707|1708|1709|171|18[56])\d{7,8}$/; // 联通
  var isChinaTelcom = /^(?:133|153|1700|1701|1702|177|173|18[019])\d{7,8}$/; // 电信
  return isChinaMobile.test(numStr) || isChinaUniom.test(numStr) || isChinaTelcom.test(numStr);
}

/**
 * 判断当前的环境是否在 微信环境下
 * */
export function isWeiXin() {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}

/**
 * 判断当前是否为ios
 * */
export function isIos() {
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    return true;
  } else {
    return false;
  }
}

/**
* 判断当前是否为Android
* */
export function isAndroid() {
  if (/(Android)/i.test(navigator.userAgent)) {
    return true;
  } else {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/utils/common.js